"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalStatusAvailableAsFilter = void 0;
/**
 * @description proposal status filter
 */
var ProposalStatusAvailableAsFilter;
(function (ProposalStatusAvailableAsFilter) {
    ProposalStatusAvailableAsFilter["PUBLISHED"] = "PUBLISHED";
    ProposalStatusAvailableAsFilter["EXPIRED"] = "EXPIRED";
    ProposalStatusAvailableAsFilter["DRAFT"] = "DRAFT";
    ProposalStatusAvailableAsFilter["ARCHIVED"] = "ARCHIVED";
})(ProposalStatusAvailableAsFilter = exports.ProposalStatusAvailableAsFilter || (exports.ProposalStatusAvailableAsFilter = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcG9zYWwtc3RhdHVzLWF2YWlsYWJsZS1hcy1maWx0ZXIuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZnEvdHlwZXMvcHJvcG9zYWwtc3RhdHVzLWF2YWlsYWJsZS1hcy1maWx0ZXIuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSDs7R0FFRztBQUVILElBQVksK0JBS1g7QUFMRCxXQUFZLCtCQUErQjtJQUN6QywwREFBdUIsQ0FBQTtJQUN2QixzREFBbUIsQ0FBQTtJQUNuQixrREFBZSxDQUFBO0lBQ2Ysd0RBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUxXLCtCQUErQixHQUEvQix1Q0FBK0IsS0FBL0IsdUNBQStCLFFBSzFDIn0=